import type { BillingMetrics } from '../billing/billing.interface';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class BillingMetricsFactory extends ObjectFactory<BillingMetrics> {
  protected getDefaults(): BillingMetrics {
    return {
      ...baseDocumentFactory.build(),
      month: 9,
      taskCount: 0,
      year: 2026,
    };
  }
}

export const billingMetricsFactory = new BillingMetricsFactory();
